export const calculateTimeDifferenceIsSeconds = (timestamp: string | number | Date): number => {
  const timestampDate = new Date(timestamp);
  const currentDate = new Date();
  return (currentDate.getTime() - timestampDate.getTime()) / 1000;
};
